module.exports = __webpack_public_path__ + "static/media/tq12.6ce754d4.jpg";